/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {

  // Any custom JS goes in here

  window.theme = window.theme || {};

  window.theme.buttonColors = {
    colors: [],
    currentColorIndex: 0,
    
    init() {
      if (!theme.settings.enableRandomHover) return;
      
      // Get colors once and store them
      this.colors = [
        getComputedStyle(document.documentElement).getPropertyValue('--BTN-HOVER-COLOR-1').trim(),
        getComputedStyle(document.documentElement).getPropertyValue('--BTN-HOVER-COLOR-2').trim(),
        getComputedStyle(document.documentElement).getPropertyValue('--BTN-HOVER-COLOR-3').trim(),
        getComputedStyle(document.documentElement).getPropertyValue('--BTN-HOVER-COLOR-4').trim()
      ].filter(Boolean);
      
      if (this.colors.length === 0) return;

      // Initial setup
      this.setupButtons();
      
      // Setup MutationObserver to watch for new buttons
      this.setupMutationObserver();
    },

    setupButtons() {
      document.querySelectorAll('.btn--white:not([data-color-initialized])').forEach(btn => {
        
        // Mark the button as initialized
        btn.setAttribute('data-color-initialized', 'true');
        
        // Set initial color
        btn.style.setProperty('--btn-bg-hover', this.colors[0]);

        // Add transition end listener
        btn.addEventListener('transitionend', (e) => {
          if (e.propertyName === 'transform' && !btn.matches(':hover')) {
            this.currentColorIndex = (this.currentColorIndex + 1) % this.colors.length;
            const nextColor = this.colors[this.currentColorIndex];
            btn.style.setProperty('--btn-bg-hover', nextColor);
          }
        });
      });
    },

    setupMutationObserver() {
      // Create a MutationObserver to watch for new buttons
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.addedNodes.length) {
            // Small timeout to ensure dynamic content is fully loaded
            setTimeout(() => this.setupButtons(), 100);
          }
        });
      });

      // Start observing the entire document for dynamically added buttons
      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    }
  };

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => window.theme.buttonColors.init());
  } else {
    window.theme.buttonColors.init();
  }

  
})();
